import apiInstance from '@api/index';
import toastMessage from '@components/Toast';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RunDeliverableEntityTradesParam } from 'pages/RunDeliverable/components/RunDeliverables/types';

import {
  CompanyEntityListResponse,
  CompanyEntityTransactionsResponse,
} from './types';

export const companyEntityTransactions = createAsyncThunk<
  CompanyEntityTransactionsResponse,
  RunDeliverableEntityTradesParam,
  { rejectValue: string }
>(
  'deliverables/companyEntityTransactions',
  async (params, { rejectWithValue }) => {
    try {
      toastMessage.info('Loading Company Entity Transactions...');
      const response = await apiInstance.companyEntity.companyTradesWithInfo({
        comp_entity_id: params.comp_entity_id,
      });
      if (response && response.data.success === true) {
        toastMessage.success('Company Entity Transactions loaded successfully');
      }
      return response.data;
    } catch (error) {
      if (error instanceof Error) {
        toastMessage.error(
          'Failed to load company entity transactions. ' + error.message,
        );
        return rejectWithValue(error.message);
      }
      return rejectWithValue('Failed to load company entity transactions');
    }
  },
);

export const companyEntityList = createAsyncThunk<
  CompanyEntityListResponse,
  string | null,
  { rejectValue: string }
>('deliverables/companyEntityList', async (id, { rejectWithValue }) => {
  try {
    const response = await apiInstance.filters.fetchCompanyEntityList(id);
    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      toastMessage.error(
        'Failed to load company entity list. ' + error.message,
      );
      return rejectWithValue(error.message);
    }
    return rejectWithValue('Failed to load company entity list');
  }
});
